import { EntityRequestAddchg } from "../../entity/EntityRequestAddchg";

export class DtoRequestAddchgsPostRes extends EntityRequestAddchg {}
